<template>
    <router-view/>
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if(to.name == `${to.meta.abrev}-motivo`){
            next({ name: `${to.meta.abrev}-motivo-list` })
        }else{
            next()
        }
    },
    created() {
        console.log(`${this.$route.meta.abrev}-centro-custo`);
        if(this.$route.name == `${this.$route.meta.abrev}-motivo`){
            this.$router.push({ name: `${this.$route.meta.abrev}-motivo-list` })
        }
    }
}
</script>